import {NgModule} from '@angular/core';
import {NotesComponents, NotesServices} from './index';
import * as angular from 'angular';
import {CheckboxModule,} from 'primeng/checkbox';
import {TableModule,} from 'primeng/table';
import {DropdownModule,} from 'primeng/dropdown';
import {EditorModule,} from 'primeng/editor';
import {InputSwitchModule} from 'primeng/inputswitch';
import {OverlayPanelModule,} from 'primeng/overlaypanel';
import {SharedModule as PNGShared} from 'primeng/api';

import {SharedModule} from '../shared/shared.module';
import {LayoutModule} from '../layout/layout.module';
import {UserModule} from '../user/user.module';
import {FormsModule} from '@angular/forms';
import {NotesComponent} from './components/notes/notes.component';
import {CoreModule} from '../core/core.module';
import {AberrationCommentsComponent} from './components/aberration-comments/aberration-comments.component';
import {RichNotesComponent} from './components/rich-notes/rich-notes.component';
import {AddRichNotesComponent} from './components/add-rich-notes.component/add-rich-notes.component';
import {SimpleNotesComponent} from "./components/simple-notes.component/simple-notes.component";

@NgModule({
  imports: [
    CoreModule,
    SharedModule,
    LayoutModule,
    TableModule,
    PNGShared,
    UserModule,
    EditorModule,
    FormsModule,
    DropdownModule,
    InputSwitchModule,
    CheckboxModule,
    OverlayPanelModule,
  ],
  declarations: [...NotesComponents, RichNotesComponent, AddRichNotesComponent, SimpleNotesComponent],
  exports: [...NotesComponents, RichNotesComponent, AddRichNotesComponent, SimpleNotesComponent],
  providers: [...NotesServices
  ]
})
export class NotesModule {
}
